// ALL DATA BELOW IS MOCKED (scraped/static) no backend yet.
// Images & videos are the real assets hosted on volunteering.org.au

export const IMG = {
  heroBeach:
    "/assets/img/2026-04-nik-schmidt-pZRAmXGTnHo-unsplash-1920x1080.jpg",
  fijiNutrition:
    "/assets/img/2026-04-81b3d523-0f53-49fa-ac15-87748b4d03fa-1024x576.jpg",
  malawiTeaching:
    "/assets/img/2025-10-Mangochi-Teaching-11-3-768x1024.jpg",
  turtleLombok:
    "/assets/img/2025-04-LINE_ALBUM_lombok-turtle-conservation-august-2024_240826_34-2-800x600.jpg",
  turtleGroup: "/assets/img/2016-02-turtle-1.jpg",
  turtleClose:
    "/assets/img/2016-02-turtle-1-e1648219521621.jpg",
  ricePaddiesWalk:
    "/assets/img/elementor-thumbs-walking-through-rice-paddies-2-qk9uekdmdu3m-331498.jpg",
  templeWater:
    "/assets/img/elementor-thumbs-Ubud-introduction-week-Tirta-38-qk9ueq0niub-e906cf.jpg",
  waterfall:
    "/assets/img/elementor-thumbs-waterfall-surrounded-by-green-trees-2-qk9ue-5aeab1.jpg",
  blueWater: "/assets/img/2024-10-blue-water.jpg",
  baliTeaching:
    "/assets/img/2016-03-green-lion-teaching4.jpg",
  baliKindergarten:
    "/assets/img/2016-03-green-lion-kindergarten7.jpg",
  ricePaddies:
    "/assets/img/2016-03-bali-rice-paddies.jpg",
  uluwatu:
    "/assets/img/2019-12-uluwatu-temple-bali.jpg",
  kuta: "/assets/img/2019-12-kuta-beach-bali.jpg",
  seminyak:
    "/assets/img/2019-12-where-to-stay-seminyak.jpg.jpg",
  nusaLombogan:
    "/assets/img/2019-12-nusa-lombogan.jpg",
  mountAgung:
    "/assets/img/2019-12-Mount-agung-with-balinese-statue-in-front.jpg",
  market: "/assets/img/2016-03-green-lion-teaching4.jpg",
  capeVerde:
    "/assets/img/2019-11-Cape-Verde-blog-10-1024x768.jpg",
  ghanaSports:
    "/assets/img/2019-12-Sports-coaching-ghana-9.jpg",
  teachingAnimals:
    "/assets/img/2020-04-Participant-teaching-animal-names-in-English-with-drawings-min-1.webp",
  ebook1:
    "/assets/img/2022-12-Modern-eBook-Mockup-for-Coaches-Facebook-Post-2-min.webp",
  ebook2:
    "/assets/img/2022-12-smartmockups_lbbkkrga-1-min.webp",
};

export const VIDEOS = {
  bali: {
    id: "Oswwv4XfFqs",
    title: "Be Inspired and Connect with the Beautiful People of Bali!",
    channel: "Involvement Volunteers International",
  },
};

export const NAV = [
  { label: "Home", to: "/" },
  {
    label: "Destinations",
    children: [{ label: "Volunteer in Bali", to: "/projects/volunteer-in-bali" }],
  },
  { label: "Blog", to: "/blog/find-out-more-about-cape-verde" },
  {
    label: "Sitemap",
    children: [
      { label: "Sitemap page 1", to: "/sitemap" },
      { label: "Sitemap page 2", to: "/sitemap/2" },
      { label: "Sitemap page 3", to: "/sitemap/3" },
      { label: "Sitemap page 4", to: "/sitemap/4" },
      { label: "Sitemap page 5", to: "/sitemap/5" },
      { label: "Sitemap page 6", to: "/sitemap/6" },
      { label: "Sitemap page 7", to: "/sitemap/7" },
      { label: "Sitemap page 8", to: "/sitemap/8" },
    ],
  },
];

export const STATS = [
  { value: 32643, label: "Volunteers booked", suffix: "" },
  { value: 35, label: "Years of impact", suffix: "+" },
  { value: 200, label: "Projects worldwide", suffix: "+" },
  { value: 20, label: "Countries", suffix: "+" },
];

// Engaging media wall for the homepage (real photos + the real IVI Bali video)
export const MEDIA_WALL = [
  {
    id: "m1",
    type: "video",
    videoId: VIDEOS.bali.id,
    poster: IMG.templeWater,
    title: "Be inspired by the people of Bali",
    tag: "Film",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    id: "m7",
    type: "photo",
    src: "/assets/img/moment-turtle-hands.webp",
    title: "First health check at the turtle centre",
    tag: "Conservation",
    span: "lg:col-span-1 lg:row-span-2",
  },
  {
    id: "m8",
    type: "photo",
    src: "/assets/img/moment-puppies-hug.webp",
    title: "Two rescues, one very happy volunteer",
    tag: "Animal Rescue",
    span: "lg:col-span-1 lg:row-span-2",
  },
  {
    id: "m9",
    type: "photo",
    src: "/assets/img/moment-teaching-alphabet.webp",
    title: "A B C on the classroom floor",
    tag: "Teaching",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    id: "m10",
    type: "photo",
    src: "/assets/img/moment-turtle-tank.webp",
    title: "Hatchling in gloved hands, tank 16",
    tag: "Wildlife",
    span: "lg:col-span-1 lg:row-span-2",
  },
  {
    id: "m11",
    type: "photo",
    src: "/assets/img/moment-puppy-lap.webp",
    title: "Nap time on a volunteer's lap",
    tag: "Animal Rescue",
    span: "lg:col-span-1 lg:row-span-2",
  },
  {
    id: "m3",
    type: "photo",
    src: IMG.malawiTeaching,
    title: "Classrooms in Mangochi, Malawi",
    tag: "Teaching",
    span: "lg:col-span-1 lg:row-span-2",
  },
  {
    id: "m2",
    type: "photo",
    src: IMG.turtleLombok,
    title: "Releasing turtles in Lombok",
    tag: "Conservation",
    span: "lg:col-span-1 lg:row-span-1",
  },
  {
    id: "m4",
    type: "photo",
    src: IMG.turtleGroup,
    title: "Turtle sanctuary crew",
    tag: "Wildlife",
    span: "lg:col-span-1 lg:row-span-1",
  },
  {
    id: "m5",
    type: "photo",
    src: IMG.nusaLombogan,
    title: "Island escapes on your weekends",
    tag: "Adventure",
    span: "lg:col-span-1 lg:row-span-1",
  },
  {
    id: "m6",
    type: "photo",
    src: IMG.ghanaSports,
    title: "Sports coaching in Ghana",
    tag: "Community",
    span: "lg:col-span-3 lg:row-span-1",
  },
];

export const PILLARS = [
  {
    icon: "LifeBuoy",
    title: "24/7 Support",
    text: "An excellent safety record, in-country round the clock support & emergency assistance.",
  },
  {
    icon: "BedDouble",
    title: "Top Accommodation",
    text: "Secure, safe and clean accommodation. Stay in a homestay for an authentic experience.",
  },
  {
    icon: "Trophy",
    title: "Amazing Record",
    text: "IVI have successfully placed over 32,000 volunteers in overseas projects since 1989.",
  },
  {
    icon: "ShieldCheck",
    title: "Quality Projects",
    text: "We audit every project to make sure they are ethical and meet long-term community goals.",
  },
];

export const WHY_IVI = [
  {
    icon: "HeartHandshake",
    title: "Make a Real Impact",
    text: "We focus on projects with genuine needs community, healthcare, education, childcare, construction. You'll leave feeling like you truly achieved something.",
  },
  {
    icon: "Star",
    title: "Top Rated",
    text: "Voted 'Top Overseas Volunteering Organisation' by APAC Insider Australia awards, with thousands of positive testimonies.",
  },
  {
    icon: "CheckCircle2",
    title: "35+ Years in Operation",
    text: "IVI is one of the pioneers of overseas volunteering. Established in 1989 with trustworthy partners who know local needs.",
  },
  {
    icon: "Sprout",
    title: "Charity & Non Profit",
    text: "We don't just send volunteers overseas we run campaigns and fundraise for materials so our impact is lasting.",
  },
  {
    icon: "Wallet",
    title: "Honest, Low Fees",
    text: "One application fee, multiple countries. Your program fee goes to accommodation, food, transport and the community.",
  },
];

export const DESTINATIONS = [
  {
    slug: "/projects/volunteer-in-bali",
    name: "Bali & Indonesia",
    projects: 13,
    from: 475,
    img: IMG.ricePaddies,
    blurb:
      "Turtles, kindergartens, rice terraces and the warmest welcome in Asia. Four locations, thirteen audited projects and volunteers arriving every week.",
  },
];

// Used by the interactive "Find Your Project Match" tool
export const MATCH_OPTIONS = {
  interest: [
    "Wildlife & Conservation",
    "Teaching & Childcare",
    "Healthcare & Nutrition",
    "Community & Construction",
  ],
  region: ["Asia", "Africa", "Pacific"],
  duration: ["12 weeks", "34 weeks", "5+ weeks"],
};

export const PROJECTS = [
  {
    id: "p1",
    name: "Turtle Conservation",
    place: "Lombok, Indonesia",
    interest: "Wildlife & Conservation",
    region: "Asia",
    duration: "12 weeks",
    price: 475,
    img: IMG.turtleLombok,
    popular: true,
    blurb:
      "Clean tanks, measure and care for hatchlings, run beach clean-ups and release turtles to the sea.",
  },
  {
    id: "p2",
    name: "Kindergarten & Teaching",
    place: "Ubud, Bali",
    interest: "Teaching & Childcare",
    region: "Asia",
    duration: "34 weeks",
    price: 445,
    img: IMG.baliKindergarten,
    blurb:
      "Support local teachers with English, songs, games and creative play in village kindergartens.",
  },
  {
    id: "p3",
    name: "Public Health & Nutrition",
    place: "Suva, Fiji",
    interest: "Healthcare & Nutrition",
    region: "Pacific",
    duration: "34 weeks",
    price: 620,
    img: IMG.fijiNutrition,
    blurb:
      "Run by a qualified health professional educate communities on nutrition and wellbeing.",
  },
  {
    id: "p4",
    name: "Community Construction",
    place: "Nusa Penida, Bali",
    interest: "Community & Construction",
    region: "Asia",
    duration: "12 weeks",
    price: 465,
    img: IMG.waterfall,
    blurb:
      "Build and renovate classrooms, water tanks and community spaces alongside local tradespeople.",
  },
  {
    id: "p5",
    name: "Sports Coaching",
    place: "Accra, Ghana",
    interest: "Teaching & Childcare",
    region: "Africa",
    duration: "5+ weeks",
    price: 495,
    img: IMG.ghanaSports,
    blurb:
      "Coach football, netball and athletics build confidence, teamwork and discipline.",
  },
  {
    id: "p6",
    name: "Teaching in Mangochi",
    place: "Mangochi, Malawi",
    interest: "Teaching & Childcare",
    region: "Africa",
    duration: "5+ weeks",
    price: 460,
    img: IMG.malawiTeaching,
    blurb:
      "Lakeside classrooms with big classes and even bigger smiles. Bring your lesson plans!",
  },
  {
    id: "p7",
    name: "Marine & Beach Conservation",
    place: "Sal, Cape Verde",
    interest: "Wildlife & Conservation",
    region: "Africa",
    duration: "34 weeks",
    price: 540,
    img: IMG.capeVerde,
    blurb:
      "Loggerhead turtle nest patrols, data collection and marine plastic clean-ups.",
  },
  {
    id: "p8",
    name: "Healthcare Assistant",
    place: "Lovina, Bali",
    interest: "Healthcare & Nutrition",
    region: "Asia",
    duration: "34 weeks",
    price: 510,
    img: IMG.baliTeaching,
    blurb:
      "Shadow nurses and doctors in local clinics, assist with health checks and education.",
  },
];

export const FEATURED = {
  ribbon: "POPULAR",
  eyebrow: "Featured Project",
  title: "Turtle Conservation in Bali",
  price: 475,
  currency: "USD",
  note: "p/person + application fee",
  img: IMG.turtleLombok,
  body:
    "Sea turtles in Indonesian islands face habitat destruction from coastal development, pollution and climate change. Help at the local sanctuary cleaning tanks, measuring & cleaning turtles, beach cleaning & feeding turtles!",
  includes: [
    { icon: "BedDouble", label: "Accommodation" },
    { icon: "Car", label: "In-country transportation" },
    { icon: "Apple", label: "3 meals a day" },
    { icon: "CheckCircle2", label: "In-country 24/7 support" },
    { icon: "Plane", label: "Airport pickup" },
  ],
  quote:
    "Volunteering was the best experience of my life! The turtles are so cute and it was very fulfilling to take care of them. I met loads of amazing people, visited places that looked absolutely out of this world, and gained lots of independence. The coordinators are amazing: easygoing, funny, dedicated and always there to make you smile.",
  author: "Maitreyi",
};

export const BLOG = [
  {
    title: "Find out more about Cape Verde!",
    excerpt:
      "IVI have some exciting new projects in the stunning and unique country of Cape Verde. Never heard of it? This post tells you everything about this beautiful African island.",
    img: IMG.capeVerde,
    date: "22 July 2026",
    tag: "Blog",
  },
  {
    title: "How to Create a Lesson Plan for Teaching Overseas",
    excerpt:
      "So, you've booked a project teaching overseas but have no idea where to start? This post outlines lesson plan ideas and gives you confidence for the classroom.",
    img: IMG.teachingAnimals,
    date: "22 July 2026",
    tag: "Blog",
  },
  {
    title: "Best Sports Coaching Abroad Projects with IVI",
    excerpt:
      "Sports coaching abroad is a fantastic way to combine travel, cultural exchange and community impact. Here are the best IVI programs to consider.",
    img: IMG.ghanaSports,
    date: "22 July 2026",
    tag: "Blog",
  },
];

export const INSTA = [
  IMG.turtleGroup,
  IMG.ricePaddiesWalk,
  IMG.turtleClose,
  IMG.waterfall,
  IMG.templeWater,
  IMG.baliTeaching,
  IMG.uluwatu,
  IMG.baliKindergarten,
  IMG.nusaLombogan,
  IMG.mountAgung,
];

export const GET_STARTED = [
  {
    icon: "FileText",
    title: "Apply Now",
    text: "Ready to volunteer abroad? Complete your application online in 2 minutes.",
    cta: "Start application",
  },
  {
    icon: "MessageCircle",
    title: "Need More Info?",
    text: "Not sure which program is right for you? Contact us for more info.",
    cta: "Contact us",
  },
  {
    icon: "CalendarClock",
    title: "Schedule a Call",
    text: "Let's talk about it! Pick a time and date to chat via phone or video.",
    cta: "Book a chat",
  },
];

/* ----------------------------- BALI PAGE DATA ----------------------------- */

export const BALI = {
  hero: IMG.blueWater,
  title: "Bali",
  kicker: "Indonesia · Ubud · Lovina · Lombok · Nusa Penida",
  quickStats: [
    { label: "Projects", value: "13" },
    { label: "Locations", value: "4" },
    { label: "From", value: "$445 USD" },
    { label: "Support", value: "24/7" },
  ],
  whyNeeded: [
    {
      icon: "Coins",
      text: "Approx 14.3% of the population in Bali live below the poverty line.",
    },
    {
      icon: "Users",
      text: "Volunteering in this region creates employment for local staff & helps invigorate the local economy.",
    },
    {
      icon: "Droplets",
      text: "Many villages lack education and even access to clean water and electricity.",
    },
    {
      icon: "Globe2",
      text: "Bali has growing environmental problems such as pollution and freshwater scarcity.",
    },
  ],
  whyIvi: [
    "Non Profit Org & Charity with 35+ years experience",
    "13 projects to choose from in Bali",
    "Social experiences sharing with international volunteers",
    "Excellent safety record, in-country 24/7 support & emergency assistance",
    "1 application fee multiple countries",
  ],
  intro: [
    "Bali is more than beeping horns, tourist beaches, Bintang and a suntan. When you travel away from the tourist crowds, you experience something magical. Balinese people are genuinely happy, with a unique culture and spiritual lifestyle.",
    "Bali is incredibly diverse beach, mountains, islands, jungle, nightlife, beauty, culture, food, adventure… oh, and sweet coconuts and mango trees! But like many developing regions, there is a lot of poverty. We focus on projects that mean something, and take you to the areas where you can make a difference.",
  ],
  gallery: [
    { src: IMG.turtleClose, caption: "Sea turtle at the sanctuary" },
    { src: IMG.turtleGroup, caption: "Group at the turtle conservation project" },
    { src: IMG.ricePaddiesWalk, caption: "Walking through the rice paddies" },
    { src: IMG.templeWater, caption: "Bathing in the holy temple water" },
    { src: IMG.waterfall, caption: "Waterfall surrounded by green trees" },
    { src: IMG.baliKindergarten, caption: "Kindergarten in Ubud" },
    { src: IMG.baliTeaching, caption: "Teaching English in a village school" },
    { src: IMG.ricePaddies, caption: "Ubud rice terraces" },
    { src: IMG.turtleLombok, caption: "Turtle release, Lombok" },
  ],
  faqs: [
    {
      q: "Where are the projects located?",
      a: "We have many projects located in Ubud, as well as Lombok, Lovina and Nusa Penida. Ubud, pronounced 'oobood', is located centrally in the heart of Balinese culture far removed from the tourist crowds of Kuta, famous as an arts and crafts hub, surrounded by scenic rice fields, small villages, ancient temples, palaces and rivers. Lovina is a picturesque coastal area 9km west of Singaraja in Northern Bali with dolphin watching, waterfalls and hot springs. Lombok, about 35km from Bali, is an authentic Indonesian island known for picturesque beaches, prime surfing and very few tourists. Nusa Penida is a breathtaking island southeast of Bali that maintains its untouched charm.",
    },
    {
      q: "What are my accommodation options?",
      a: "In Ubud, standard accommodation is shared bedrooms in well equipped, dedicated volunteer guest houses on the outskirts of Ubud within genuine local Balinese communities pigs, chickens, roosters crowing… a real Balinese experience. Expect to share a room with 4 to 8 other volunteers. Bathrooms are shared with hot water and western toilets. Wifi is available in common areas, laundry is within walking distance and Ubud centre is 1520 min by car with 2 complimentary taxi drops per week. In Lovina, our accommodation centre (Vedanta) sits near both beach and mountains. In Lombok, Senggigi offers spacious rooms, hot showers and a private bathroom shared between 46 volunteers. In Nusa Penida the centre is in Ped Village between the beachfront road and the commercial area. Upgrades (single room, private room or private villa) start from approx US$125 p/week.",
    },
    {
      q: "Is food included?",
      a: "You'll receive 3 traditional meals each day on weekdays and 2 meals on weekends (breakfast and dinner). Expect nasi goreng, mie goreng or gado gado and lots of tofu and tempeh for non meat eaters. Breakfasts include pancakes, fresh fruit and toast. Tea, coffee and purified water are available at the volunteer house. Let us know any dietary requirements when you apply.",
    },
    {
      q: "Is there an orientation?",
      a: "You may choose a 1 week introduction to Indonesia to ease into the lifestyle and pace, and get to know your town, its facilities, customs, culture, travel options, safety and information about your chosen project. It's also a great chance to meet other volunteers and swap contact details for weekend travel. Prefer to dive straight in? You'll receive a short briefing and be introduced to your volunteer coordinator.",
    },
    {
      q: "Is transport included?",
      a: "An arrival airport pickup is included in the cost of your placement, and accommodation on the Sunday is included in the program fees. Arrivals are on Saturdays and Sundays (check the individual project for pickup window times). If arriving outside the pickup times we can arrange a private transfer and extra night's accommodation, subject to availability.",
    },
    {
      q: "Do I get to explore the sights & surrounds?",
      a: "Weekends are always free for relaxing or sightseeing. Our ground operators help you organise additional trips at special non-tourist rates, payable in local currency. Be sure to check out the beaches of Seminyak, Kuta and Sanur, cycling and trekking tours on Mount Batur, local temples and rice terraces.",
    },
    {
      q: "How can I raise funds for my trip?",
      a: "Check out our step-by-step guide to crowdfunding your overseas volunteer experience to help maximise your impact abroad.",
    },
  ],
  tours: [
    {
      name: "Tegallalang Rice Terraces",
      area: "Gianyar",
      img: IMG.ricePaddiesWalk,
      text: "Walk the iconic emerald terraces of Tegallalang in the Gianyar Regency best at sunrise, before the tour buses arrive.",
    },
    {
      name: "Uluwatu",
      area: "Bali",
      img: IMG.uluwatu,
      text: "A temple built on the edge of a 70-metre cliff above the sea, inhabited by monkeys. Also a world class surf break with consistent 810 foot surf and incredible coastal views.",
    },
    {
      name: "Ubud",
      area: "Bali",
      img: IMG.ricePaddies,
      text: "Famous as an arts and crafts hub with a general feeling of wellbeing (many spas here!). Scenic rice fields, small villages, craft communities, ancient temples, palaces and rivers.",
    },
    {
      name: "Kuta",
      area: "Bali",
      img: IMG.kuta,
      text: "Known for its party atmosphere, Kuta is the quintessential Bali spot for young travellers with loads of bars, restaurants and beaches.",
    },
    {
      name: "Nusa Lembongan",
      area: "Bali",
      img: IMG.nusaLombogan,
      text: "An island paradise with some of the clearest water you'll ever see. Peace, tranquillity, nature hikes and warm Balinese hospitality plus surfing, diving and snorkelling.",
    },
    {
      name: "Holy Mount Agung",
      area: "Bali",
      img: IMG.mountAgung,
      text: "The highest point on the island at 3,031 metres an active volcano that last erupted in 2017. Indonesia has around 400 volcanoes, 127 of them active.",
    },
    {
      name: "Seminyak",
      area: "Bali",
      img: IMG.seminyak,
      text: "The more up-market and stylish part of Bali with beautiful beaches, resorts, incredible dining and a laid back tourist vibe worth experiencing.",
    },
  ],
};
